import { useContext } from "react";
import {
  MySection,
  AboutMe,
  AboutTitle,
  AboutTitleWrapper,
  BuildThingsFor,
  CaseStudyChildWrapper,
  CaseStudyDate,
  CaseStudySubTitle,
  CaseStudyTitle,
  CaseStudyTitleWrapper,
  CaseStudyWrapper,
  ChildContactSectionWrapper,
  ChildFirstSectionWrapper,
  ChildSecondSectionWrapper,
  ChildThirdSectionWrapper,
  Contact,
  ContactButton,
  ContactSectionWrapper,
  ContactText,
  ContentWrapper,
  FirstPara,
  FirstSectionWrapper,
  GetInTouch,
  HelloMyNameIs,
  HorizLine,
  Introduction,
  MyGoal,
  MyName,
  NoContactWrapper,
  SayHelloButton,
  SecondPara,
  SecondSectionWrapper,
  TechsWrapper,
  ThirdSectionWrapper,
  ThridPara,
  WhatsNext,
  WorkedOnTitle,
  WorkedOnTitleWrapper,
  ParaWrapper,
  DesignedBy,
  DesignByWrapper,
} from "./Content.styled";
import VerticalTabs from "./VerticalTabs/VerticalTabs";
import VerticalTimeline from "./VerticalTimeline/VerticalTimeline";
import { DrawerContext } from "../ReactContext/DrawerContext";
import { Link } from "react-router-dom";
import { Typewriter } from "../common/Typewriter";
// import { data, verticalComponentData } from "./VerticalTimeline/mockData";

export const Content = () => {
  const { showSidebar } = useContext(DrawerContext);
  // console.log("testing", showSidebar);

  return (
    <main>
      {/* {HomePageSection.map((section) => {
        return (
            <section>
            </section>
        )
    })} */}
      <ContentWrapper className="ContentWrapper prevent-select">
        <MySection
          className="section-offset"
          isOpen={showSidebar}
          style={{
            alignItems: "center",
            // backgroundColor: "darkgrey",
          }}
        >
          <FirstSectionWrapper className="FirstSectionWrapper">
            <ChildFirstSectionWrapper>
              <Introduction>&lt;Introduction&gt;</Introduction>
              <HelloMyNameIs>Hello, my name is</HelloMyNameIs>
              <MyName>
                <Typewriter
                  text="Vasil HT"
                  transition={{ delay: 0.8 }}
                  delay={0}
                />
                {/* Vasil HT<span>.</span> */}
              </MyName>
              <BuildThingsFor>
                <Typewriter
                  text="I build things for the web"
                  transition={{ delay: 3.7 }}
                  delay={0.8}
                />
              </BuildThingsFor>
              <MyGoal>
                My ultimate goal is to create visually appealing & seamless user
                experiences that drive engagement and conversions.
              </MyGoal>
              <Link to="/contact-form">
                <ContactButton>Contact me</ContactButton>
              </Link>
              <Introduction>&lt;/Introduction&gt;</Introduction>
            </ChildFirstSectionWrapper>
          </FirstSectionWrapper>
        </MySection>
        <MySection
          className="section-offset"
          isOpen={showSidebar}
          id="About"
          style={{
            alignItems: "center",
            // backgroundColor: "green",
          }}
        >
          <SecondSectionWrapper className="SecondSectionWrapper">
            <ChildSecondSectionWrapper>
              <AboutMe>&lt;AboutMe&gt;</AboutMe>
              <AboutTitleWrapper className="AboutTitleWrapper">
                <AboutTitle className="AboutTitle">
                  01.<span>About me</span>
                </AboutTitle>
                <HorizLine />
              </AboutTitleWrapper>
              <ParaWrapper>
                <FirstPara>
                  Hello, my name is Vasil, and I am a front-end developer with a
                  passion for creating beautiful and functional websites. My
                  journey in technology began at a young age, leading to a
                  commitment to transforming ideas into functional solutions.
                </FirstPara>
                <SecondPara>
                  At Banzae, I have played a pivotal role in developing
                  innovative applications, including a fitness solution and a
                  comprehensive redesign of an outdated platform into a
                  Progressive Web Application (PWA). Leveraging a modern tech
                  stack—such as Next.js, React, TypeScript, Zustand,
                  react-query, and Material-UI—I consistently deliver highly
                  responsive and user-centric interfaces. My contributions are
                  grounded in Agile methodologies, where I adeptly manage tasks
                  using Jira and ensure seamless code integration through
                  Bitbucket.
                </SecondPara>
                <ThridPara>
                  The technologies I actively work with include:
                </ThridPara>
                <TechsWrapper>
                  <span>
                    <p>&gt; Next.js</p>
                    <p>&gt; React</p>
                    <p>&gt; TypeScript</p>
                  </span>
                  <span>
                    <p>&gt; react-query</p>
                    <p>&gt; zustand</p>
                    <p>&gt; Material-ui</p>
                  </span>
                  <span>
                    <p>&gt; styled-components </p>
                    <p>&gt; Figma</p>
                    <p>&gt; Git</p>
                  </span>
                </TechsWrapper>
              </ParaWrapper>
              <AboutMe>&lt;/AboutMe&gt;</AboutMe>
            </ChildSecondSectionWrapper>
          </SecondSectionWrapper>
        </MySection>
        <MySection
          className="section-offset"
          isOpen={showSidebar}
          id="Work"
          style={{
            // alignItems: "center",
            flexDirection: "column",
            // backgroundColor: "teal",
          }}
        >
          <ThirdSectionWrapper>
            <ChildThirdSectionWrapper>
              <AboutMe>&lt;WorkSection&gt;</AboutMe>
              <WorkedOnTitleWrapper className="WorkedOnTitleWrapper">
                <WorkedOnTitle className="WorkedOnTitle">
                  02.<span>Things I've worked on</span>
                </WorkedOnTitle>
                <HorizLine />
              </WorkedOnTitleWrapper>
              <VerticalTabs />
              <AboutMe className="">&lt;/WorkSection&gt;</AboutMe>
            </ChildThirdSectionWrapper>
          </ThirdSectionWrapper>
        </MySection>
        <MySection
          className="section-offset"
          isOpen={showSidebar}
          id="CaseStudy"
          style={{
            flexDirection: "column",
            // backgroundColor: "orange",
          }}
        >
          <CaseStudyWrapper>
            <CaseStudyChildWrapper>
              <CaseStudyTitleWrapper>
                <CaseStudyTitle>
                  03.<span> Case Study</span>
                </CaseStudyTitle>
                <CaseStudySubTitle>
                  on{" "}
                  <span className="allow-select">
                    <a href="https://kreativa.com.mk/">kreativa.com.mk</a>
                  </span>
                </CaseStudySubTitle>
                <CaseStudyDate>May 2022 - Oct 2022</CaseStudyDate>
              </CaseStudyTitleWrapper>
              <VerticalTimeline />
            </CaseStudyChildWrapper>
          </CaseStudyWrapper>
        </MySection>
        <MySection
          className="section-offset"
          isOpen={showSidebar}
          id="Contact"
          style={{
            alignItems: "center",
            // backgroundColor: "purple",
          }}
        >
          <ContactSectionWrapper className="ContactSectionWrapper">
            <ChildContactSectionWrapper>
              <Contact className="">&lt;Contact&gt;</Contact>
              <NoContactWrapper>
                <WhatsNext>04. What's next?</WhatsNext>
                <GetInTouch>Get in touch</GetInTouch>
                <ContactText>
                  If you're interested in learning more about my work or would
                  like to discuss potential opportunities, please don't hesitate
                  to contact me. I am currently open to new opportunities and
                  would be happy to hear from you. Whether you have a question
                  or just want to say hi, feel free to reach out and I'll do my
                  best to respond as soon as possible.
                </ContactText>
                <Link to="/contact-form">
                  <SayHelloButton>Say Hello</SayHelloButton>
                </Link>
              </NoContactWrapper>
              <Contact>&lt;/Contact&gt;</Contact>
            </ChildContactSectionWrapper>
            <DesignByWrapper>
              <a href="https://www.linkedin.com/in/vasilht/">
                <DesignedBy>
                  Designed & Developed by Vasil Hadzi-Tosev
                </DesignedBy>
              </a>
            </DesignByWrapper>
          </ContactSectionWrapper>
        </MySection>
      </ContentWrapper>
    </main>
  );
};
